import React from 'react';
import Box from '@material-ui/core/Box';
import { string, arrayOf, shape, number, func, oneOfType, bool } from 'prop-types';
import SelectableCard from '../Cards/SelectableCard';

const RadioCardGroup = ({ cards, selected, onClick }) => (
  <Box display="flex" justifyContent="space-around" flexDirection={{ xs: 'column', md: 'row' }}>
    {cards.map(({ title, description, icon, value }, i) => (
      <SelectableCard
        id={`selectable-card-${i}`}
        title={title}
        description={description}
        icon={icon}
        key={value}
        isSelected={selected === value}
        onClick={() => onClick(value)}
      />
    ))}
  </Box>
);

RadioCardGroup.propTypes = {
  cards: arrayOf(
    shape({
      title: string.isRequired,
      value: oneOfType([string, bool]),
      description: string,
      icon: shape({
        alt: string.isRequired,
        svg: string.isRequired,
        height: number,
      }),
    }),
  ).isRequired,
  onClick: func.isRequired,
  selected: oneOfType([string, bool]),
};

RadioCardGroup.defaultProps = {
  selected: '',
};

export default RadioCardGroup;
